import AppConfig from '../../src/entities/AppConfig';
import { WebClient } from './server/WebClient';

export const AppConfigService = {
    getAppConfig: () => WebClient.Get<AppConfig>("api/AppConfig")
}
